export const normalizeMemoPhone = (value) => {
  const phone = value ? value.toString().trim() : "";
  if (!phone || ["null", "<null>", "undefined"].includes(phone.toLowerCase())) {
    return null;
  }
  return phone.replace(/\W+/g, "") || null;
};

export const getDealerContactMapping = (memoData = {}) => {
  const isDealerFlow = memoData?.is_include_dealercontact === true;
  const dealerBusinessName =
    memoData?.dealerbusinessname ||
    memoData?.billingbusinessname ||
    memoData?.shippingbusinessname ||
    null;
  const dealerPhone = normalizeMemoPhone(
    memoData?.dealerphone || memoData?.billingphone || memoData?.shippingphone,
  );
  const dealerCountryCode =
    memoData?.dealercountrycode ||
    memoData?.billingphonecountrycode ||
    memoData?.shippingphonecountrycode ||
    "";
  const dealerEmail =
    memoData?.dealeremail || memoData?.billingemail || memoData?.shippingemail || null;
  const dealerAddress1 =
    memoData?.dealeraddress1 || memoData?.billingaddress1 || memoData?.shippingaddress1 || null;
  const dealerAddress2 =
    memoData?.dealeraddress2 || memoData?.billingaddress2 || memoData?.shippingaddress2 || null;
  const dealerCity =
    memoData?.dealercity || memoData?.billingcity || memoData?.shippingcity || null;
  const dealerCountry =
    memoData?.dealercountryname || memoData?.billingcountry || memoData?.shippingcountry || "United States";
  const dealerState =
    memoData?.dealerstatename || memoData?.billingstates || memoData?.shippingstates || null;
  const dealerZip =
    memoData?.dealerzipcode || memoData?.billingzipcode || memoData?.shippingzipcode || null;

  const billingName = isDealerFlow
    ? dealerBusinessName || memoData?.billingcontactname || memoData?.shippingcontactname || null
    : memoData?.billingcontactname || null;
  const shippingName = isDealerFlow
    ? dealerBusinessName || memoData?.shippingcontactname || memoData?.billingcontactname || null
    : memoData?.shippingcontactname || null;

  return {
    isDealerFlow,
    billingName,
    billingBusinessName: isDealerFlow
      ? dealerBusinessName || memoData?.billingbusinessname || null
      : memoData?.billingbusinessname || null,
    billingPhone: isDealerFlow
      ? dealerPhone || normalizeMemoPhone(memoData?.billingphone)
      : normalizeMemoPhone(memoData?.billingphone),
    billingCountryCode: isDealerFlow ? dealerCountryCode || "+1" : memoData?.billingphonecountrycode || "+1",
    billingEmail: isDealerFlow ? dealerEmail : memoData?.billingemail || null,
    billingAddress1: isDealerFlow ? dealerAddress1 : memoData?.billingaddress1 || null,
    billingAddress2: isDealerFlow ? dealerAddress2 : memoData?.billingaddress2 || null,
    billingCity: isDealerFlow ? dealerCity : memoData?.billingcity || null,
    billingCountry: isDealerFlow ? dealerCountry : memoData?.billingcountry || "United States",
    billingState: isDealerFlow ? dealerState : memoData?.billingstates || null,
    billingZip: isDealerFlow ? dealerZip : memoData?.billingzipcode || null,
    shippingName,
    shippingBusinessName: isDealerFlow
      ? dealerBusinessName || memoData?.shippingbusinessname || null
      : memoData?.shippingbusinessname || null,
    shippingPhone: isDealerFlow
      ? dealerPhone || normalizeMemoPhone(memoData?.shippingphone)
      : normalizeMemoPhone(memoData?.shippingphone),
    shippingCountryCode: isDealerFlow ? dealerCountryCode || "+1" : memoData?.shippingphonecountrycode || "+1",
    shippingEmail: isDealerFlow ? dealerEmail : memoData?.shippingemail || null,
    shippingAddress1: isDealerFlow ? dealerAddress1 : memoData?.shippingaddress1 || null,
    shippingAddress2: isDealerFlow ? dealerAddress2 : memoData?.shippingaddress2 || null,
    shippingCity: isDealerFlow ? dealerCity : memoData?.shippingcity || null,
    shippingCountry: isDealerFlow ? dealerCountry : memoData?.shippingcountry || "United States",
    shippingState: isDealerFlow ? dealerState : memoData?.shippingstates || null,
    shippingZip: isDealerFlow ? dealerZip : memoData?.shippingzipcode || null,
    dealerAccountId:
      memoData?.billing_dealercontact_accountid ||
      memoData?.shipping_dealercontact_accountid ||
      null,
    dealerUserId:
      memoData?.billing_dealercontact_userid ||
      memoData?.shipping_dealercontact_userid ||
      null,
  };
};
